import { Component, OnDestroy, AfterViewInit, EventEmitter, Input, Output, OnInit } from '@angular/core';
declare var tinymce: any;

@Component({
  selector: 'editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.css']
})
export class EditorComponent implements OnInit,AfterViewInit,OnDestroy {
  
  @Input() elementId: String;
  @Output() onEditorKeyup = new EventEmitter<any>();
  constructor() { }
  editor;

  ngAfterViewInit() {
    tinymce.init({
      selector: '#' + this.elementId,
      plugins: ['link', 'paste', 'table'],
      skin_url: 'assets/skins/lightgray',
      setup: editor => {
        this.editor = editor;
        editor.on('keyup', () => {
          const content = editor.getContent();
          this.onEditorKeyup.emit(content);
        });
      },
    });
  }

  ngOnDestroy() {
    tinymce.remove(this.editor);
  }
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/helpers/editor/editor.component.ts